import { NG_VALIDATORS, Validator, AbstractControl, ValidatorFn } from '@angular/forms';
import { Input, Directive } from '@angular/core';
import { FnInputModel } from '../model/fn-input.model';
import { FnI18nService } from '../../i18n/fn-i18.service';
import {
  FnRequireValidator,
  FnMinValidator,
  FnMaxValidator,
  FnPatternValidator,
  FnEmailValidator
} from '../model/fn-validator';
import { FN_INPUT_TYPES } from '../model/fn-form.constant';

@Directive({
  selector: '[fnInputValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: FnInputValidator, multi: true }]
})

export class FnInputValidator implements Validator {
  @Input() fieldConfig: FnInputModel;
  @Input() disabled : boolean;

  constructor(private i18nSvcs: FnI18nService) {
  }


  validate(control: AbstractControl) {

    if( this.disabled || this.fieldConfig.isDisabled){
      return null;
    }
    return this.executeValidation(control, control.value);
  }

  executeValidation(control: AbstractControl, value: any): { [key: string]: any } {
    let validatorResp: { [key: string]: any } = null;
    validatorResp = FnRequireValidator(this.i18nSvcs, this.fieldConfig)(control);
    if (this.fieldConfig.isRequired) {
      if (validatorResp != null) {
        return validatorResp;
      }
    }else if(validatorResp != null){
      return null;
    }
    if (this.fieldConfig.minLength) {
      validatorResp = FnMinValidator(this.i18nSvcs, this.fieldConfig)(control);
      if (validatorResp != null) {
        return validatorResp;
      }
    }

    if (this.fieldConfig.maxLength) {
      validatorResp = FnMaxValidator(this.i18nSvcs, this.fieldConfig)(control);
      if (validatorResp != null) {
        return validatorResp;
      }
    }
    if (this.fieldConfig.pattern) {
      validatorResp = FnPatternValidator(this.i18nSvcs, this.fieldConfig)(control);
      if (validatorResp != null) {
        return validatorResp;
      }
    }
    if (this.fieldConfig.typeID.iid === FN_INPUT_TYPES.EMAIL) {
      validatorResp = FnEmailValidator(this.i18nSvcs, this.fieldConfig)(control);
      if (validatorResp != null) {
        return validatorResp;
      }
    }
    return null;
  }
}

